<template lang="pug">
  form.contratoForm.g12(onsubmit="return false" @submit="send")
    .row.wrap.col-s
      .col.g3.g12-s
        label Nome
        input(v-model="form.nome" placeholder="Nome" required)
      .col.g3.g12-s
        label Identificador
        input(v-model="form.identificador" placeholder="Identificador" required)
      .col.g3.g12-s
        label Diretório Fornecedor
        input(v-model="form.diretorio_fornecedor" placeholder="Diretório Fornecedor" required)
      .col.g3.g12-s
        label Prefixo Contrato
        input(v-model="form.prefixo_contrato" placeholder="Prefixo Contrato" required)
      .col.g3.g12-s
        label Prefixo Minuta
        input(v-model="form.prefixo_minuta" placeholder="Prefixo Minuta" required)
      .col.g3.g12-s
        label Enviar Contrato
        Button(type="button" layout="green-s" @click="clickFile")
          .fa.fa-file-signature(style="margin-right: 6px")
          | Contrato
        .file.row.ac(v-if="this.file.percent") 
          .field.g8.g6-s(v-if="!file.notallow")
            .filler.row.je(:style="`width: ${file.percent}%`") {{ file.percent + "%" }}
        .notallow(v-if="file.notallow") O Contrato deve estar no formato 
          b PDF.
        | {{ file.name }}
      .ff.col.g3.g12-s(v-if="f")
        label Minuta
        i.fa.fa-file-signature.pointer(@click="modal.minuta=form.id;modal.show=true")
    .detail.row.js(v-if="form.id")
      .col
        label Criado em
        | {{form.criado_em | date}} por {{form.criado_por}}
      .col(v-if="form.alterado_em") 
        label Alterado em
        | {{form.alterado_em | date}} por {{form.alterado_por}}
    .row.js(style="margin-top: 30px")
      Button(type="submit" :loader="loader" layout="green-go") {{form.id ? "ATUALIZAR":"CRIAR"}}
      Button(v-if="form.id && form.status=='ativo'" @click="desativar" type="button" :loader="loader" layout="red-go") DESATIVAR
      Button(v-if="form.id && form.status=='inativo'" @click="ativar" type="button" :loader="loader" layout="green-go white") ATIVAR
    input.hide(id="attach" type="file" @change="loadFile")
    Modal(:modal="modal")
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
const initForm = {
  arquivo_minuta: "",
  diretorio_fornecedor: "",
  identificador: "",
  nome: "",
  prefixo_contrato: "",
  prefixo_minuta: ""
}
export default {
  name: "ContratoForm",
  components: { Button, Modal },
  props: { f: Object, reload: Function },
  data() {
    return {
      loader: false,
      modal: {
        show: false,
        title: "Assinatura Contrato Digital",
        layout: "ContratoDigital",
      },
      form: { ...initForm },
      file: { notallow: false, percent: 0, name: "" }
    };
  },
  beforeMount() {
    if (this.f) this.form = this.f
  },
  methods: {
    ...mapActions("admin", ["CONTRATO_CRIAR", "CONTRATO_ALTERA", "CONTRATO_ATIVA", "CONTRATO_DESATIVA"]),
    clickFile() { document.getElementById('attach').click() },
    loadFile(f) {
      this.file = { notallow: false, percent: 0, name: f.name }
      var file = f.target.files[0]
      if (file.type.match("application/pdf")) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onprogress = (e) => { if (e.lengthComputable) this.file.percent = Math.round((e.loaded / e.total) * 100) }
        reader.onload = (e) => {
          this.file.file = e.target.result;
          this.form.arquivo_minuta = e.target.result
          this.file.percent = 100
        }
      } else this.file.notallow = true

    },
    async send() {
      this.loader = true;
      if (this.form.id) await this.CONTRATO_ALTERA(this.form)
      else await this.CONTRATO_CRIAR(this.form)
      if (!this.f) this.form = { ...initForm }
      this.file = { notallow: false, percent: 0, name: "" }
      this.reload()
      this.loader = false;
    },
    async ativar() {
      this.loader = true;
      await this.CONTRATO_ATIVA(this.form.id)
      this.reload()
      this.loader = false;
    },
    async desativar() {
      if (confirm(`Tem certeza que deseja desativar o contrato: ${this.form.nome}?`)) {
        this.loader = true;
        await this.CONTRATO_DESATIVA(this.form.id)
        this.reload()
        this.loader = false;
      }

    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.contratoForm
  @include form
  .notallow
    color: $red
    font-size: 14px
    margin-top: 12px
    width: 130px
    text-align: center
  .ff
    color: $gray-1
    i
      font-size: 22px
      margin-top: 4px
      &:hover
        color: $purple
  .file
    margin-left: 12px
    margin-top: 10px
    .field 
      height: 16px
      width: 100px
      background: #ccc
      border-radius: 50px
      overflow: hidden
      margin-right: 10px
      .filler 
        height: 100%
        font-weight: bold
        background: linear-gradient(90deg, $purple 0%, $green-1 100%)
        color: white
  .detail
    margin: 20px 0
    font-size: 14px
</style>
